/** Til, mavzu va matn o'lchami boshqaruvlari — publik va kabinet tartiblarida. */
import { LANGS, useI18n } from "@/shared/i18n";
import { usePrefs } from "@/shared/lib/prefs";
import { Icon } from "@/shared/ui/Icon";

export function LangSwitch({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const { lang, setLang, t } = useI18n();
  const className = variant === "dark" ? "util-btn" : "btn btn-ghost btn-sm";

  return (
    <div role="group" aria-label={t("pref.language")} style={{ display: "flex", gap: 2 }}>
      {LANGS.map((item) => (
        <button
          key={item.code}
          type="button"
          className={className}
          aria-pressed={lang === item.code}
          lang={item.code}
          onClick={() => setLang(item.code)}
          title={item.label}
        >
          {item.short}
        </button>
      ))}
    </div>
  );
}

export function ThemeButton({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const { theme, cycleTheme } = usePrefs();
  const { t } = useI18n();
  const icon = theme === "light" ? "sun" : theme === "dark" ? "moon" : "contrast";
  const label =
    theme === "light"
      ? t("pref.theme.light")
      : theme === "dark"
        ? t("pref.theme.dark")
        : t("pref.theme.hc");

  return (
    <button
      type="button"
      className={variant === "dark" ? "util-btn" : "icon-btn"}
      onClick={cycleTheme}
      aria-label={`${t("pref.theme")}: ${label}`}
      title={`${t("pref.theme")}: ${label}`}
    >
      <Icon name={icon} size={16} />
      {variant === "dark" ? <span>{label}</span> : null}
    </button>
  );
}

export function TextSizeButton({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const { textScale, toggleTextScale } = usePrefs();
  const { t } = useI18n();

  return (
    <button
      type="button"
      className={variant === "dark" ? "util-btn" : "icon-btn"}
      onClick={toggleTextScale}
      aria-pressed={textScale === "large"}
      aria-label={t("pref.textSize.large")}
      title={t("pref.textSize.large")}
    >
      <Icon name="textSize" size={16} />
      {variant === "dark" ? <span aria-hidden="true">A+</span> : null}
    </button>
  );
}
